import React from 'react';

const EdgeGatewayPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/gateways',
			exact: true,
			component: React.lazy(() => import('./EdgeGatewayPage')),
		},
	],
};

export default EdgeGatewayPageConfig;
